import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'ConceptosFacturacion';

export interface ConceptoFacturacion {
  idConcepto: number;
  concepto: string;
	esIngenieria: boolean;
	margen: number;
}

export class ConceptosFacturacionAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarConceptosFacturacion(): AxiosPromise<ConceptoFacturacion[]> {
		return this.cliente.get(`/ListarConceptosFacturacion`);
  }

  CrearConceptosFacturacion(concepto:any): AxiosPromise<any[]> {
		return this.cliente.post(concepto,`/CrearConceptosFacturacion`);
	}
	
	EliminarConceptoFacturacion(id: number): AxiosPromise<any> {
		return this.cliente.remove(id, `/EliminarConceptosFacturacion`);
	}

	ModificarConceptosFacturacion(concepto: ConceptoFacturacion): AxiosPromise<any[]> {
		return this.cliente.put(concepto.idConcepto, concepto, `/ModificarConceptosFacturacion`);
	}
}